import React from "react";

const Plans = () => (
  <div style={{
    background: "#afc15a",
    minHeight: "60vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "28px 0"
  }}>
    <div style={{
      background: "#fff",
      borderRadius: "32px",
      padding: "36px",
      maxWidth: "900px",
      width: "96vw",
      boxSizing: "border-box",
      display: "flex",
      alignItems: "center",
      gap: "32px",
      boxShadow: "0 3px 16px rgba(0,0,0,0.07)"
    }}>
      {/* Illustration */}
      <div style={{
        flex: "1 1 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}>
        <img
          src="/assets/plans.png"
          alt="Question Illustration"
          style={{
            width: "100%",
            maxWidth: "200px",
            borderRadius: "16px",
            objectFit: "contain"
          }}
        />
      </div>
      {/* Text Content */}
      <div style={{
        flex: "2 1 0",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "flex-start"
      }}>
        <h1 style={{
          fontSize: "1.7rem",
          fontWeight: 700,
          marginBottom: "18px",
          color: "#111",
          fontFamily: "'Lato', Arial, sans-serif"
        }}>
          Ready for your next adventure?
        </h1>
        <p style={{
          fontSize: "1.05rem",
          marginBottom: "16px",
          color: "#111",
          fontFamily: "'Lato', Arial, sans-serif",
          maxWidth: "400px"
        }}>
          Unsure about your destination? Let our travel specialists design a journey tailored just for you.
        </p>
        <button
          style={{
            background: "#afc15a",
            color: "#fff",
            border: "none",
            borderRadius: "18px",
            padding: "12px 32px",
            fontSize: "1.05rem",
            fontWeight: 500,
            cursor: "pointer",
            marginBottom: "14px",
            fontFamily: "'Lato', Arial, sans-serif"
          }}
          onClick={() => {
            if (window.showContactCardOverlay) window.showContactCardOverlay();
          }}
        >
          Get a Free Quote
        </button>
        <div style={{
          fontSize: "1rem",
          color: "#111",
          fontFamily: "'Lato', Arial, sans-serif"
        }}>
          PS: Have questions? Call us anytime — we’re happy to help!
        </div>
      </div>
    </div>
  </div>
);

export default Plans;
